// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__GMJ9C","section__item":"styles_section__item__7DUSg"};